const dynamicItem = require("tpl/dynamic/dynamicitem.html");
const dynamicComment = require("tpl/dynamic/dynamiccomment.html");
const reportModel = require("tpl/dynamic/reportmodel.html");
const transmitModel = require("tpl/dynamic/transmitmodel.html");
const comment = require("tpl/topic/comment.html");
const commentInput = require("tpl/topic/commentinput.html");
const ajax = window.util.ajax;
// const collectionSuccessModel = require("tpl/dynamic/collectionsuccessmodel.html");
const __data = {
    page: 1,
    // 当前的子评论的页码
    subPage: 1,
    commentCount: 0,
    // 第一级评论的当前评论数量
    subCommentCount: 0,
    pid: 0,
    // 当前评论的深度，
    // 保存下这个level来确保当前需要刷新的评论是正确的
    level: 1,
    // 当前用户转发的动态信息
    transmitMsg: "",
    // 当前动态类型
    type: 1,
    // 是否是动态详情页
    isTopic: false,
};
const {pathname} = window.location;
const __dynamic = {
    // 处理数字的操作
    // 根据数量是否大于万来确定。如果大于万。显示多少万
    dealNumberByTenThousand(data, keys = ["comment_count", "support_count"]) {
        let keysSet = new Set(keys);

        return data.map(item => {
            for (let key in item) {
                if (keysSet.has(key)) {
                    item[key + '_deal'] = window.util.getNumberByTenThousand(item[key]);
                }
            }
            return item;
        });
    },
    // 点赞 、撤销点赞
    handleThumbs() {
        let $this = $(this),
            $currThumbCountDom = $this.find("._currThumbCount"),
            requestUrl = "",
            currThumbCount = $currThumbCountDom.attr('data-count'),
            tip = "",
            // 所有评论的点赞类型都是4
            {id} = $this.data();

        if (!$this.hasClass("_hasThumbs")) {
            requestUrl = "/support/ajaxAddSupport";
            tip = "点赞成功";
            $this.addClass('_hasThumbs');
        } else {
            requestUrl = "/support/ajaxCancelSupport";
            tip = "取消点赞成功";
            $this.removeClass('_hasThumbs');
        }
        ajax({
            url: requestUrl,
            type: "post",
            data: {
                from_id: id,
                type: __data.type
            },
            callback: ({code, msg}) => {
                if (code !== 0) {
                    layer.msg(msg);
                    return false;
                }
                layer.msg(tip);
                // 如果已经点赞就取消点赞。如果已经取消就加上点赞
                $this.hasClass("_hasThumbs") ? ++currThumbCount : --currThumbCount;
                // let showText = currThumbCount > 0 ? window.util.getNumberByTenThousand(+currThumbCount) : '点赞';
                let showText = $this.hasClass("_hasThumbs") ? '取消点赞' : '点赞';

                $currThumbCountDom.text(showText).attr('data-count', currThumbCount);
            }
        });
    },
    // 获取当前时间到评论发布之间间隔的时间
    getSinceTime(data) {
        data = data.map(item => {
            var t = window.util.getPubtime(new Date().getTime() / 1000 - item.create_time);

            item.ctime = t;
            return item;
        });
        return data;
    },
    // 点击查看评论按钮
    handleShowChildren() {
        let {level, id} = $(this).data();

        if (level === '0') {
            if (__data.$firstLevelComment === null) {
                __data.$firstLevelComment = $this.parents("._dynamicMainContent").find("._dynamicReplyContent");
            }
            __dynamic.requestFirstLevelData({type: __data.type, isAll: 0, page: 1});
        } else if (level === '1') {
            if (__data.$secondLevelComment === null) {
                __data.$secondLevelComment = $this.parents("._commentLevelOne").find("._dynamicFirstList");
            }
            __dynamic.lookSecondLevelHandle();
        }
    },
    // 获取一级列表数据
    getFirstLevelComment() {
        const {id} = $(this).data();

        __data.$firstLevel = $(this).parents("._userContent");
        __data.fromId = id || 0;
        __data.weiboId = id || 0;
        if (__data.isTopic) {
            __data.$topicCommentDom = $(this).parents('.sns-detail-block').find('.detail-block-right');
        }
        __dynamic.saveFirstComment();
        __dynamic.toggle.call(this, () => {
            // 这个状态用来判断是否当前已经有一个评论框了。如果
            __data.isOpenCommentList = false;
            __dynamic.requestFirstLevelData.call(this, {type: __data.type, page: 1});
        }, () => {
            __data.isOpenCommentList = false;
            __data.$firstLevelComment.hide().find("._dynamicFirstList,._dynamicComment").empty();
            if (__data.isTopic) {
                __data.$topicCommentDom.animate({
                    left: '-120px',
                    opacity: 0
                }, 200, () => {
                    __data.$topicCommentDom.hide();
                });
            }
        });
    },
    saveFirstComment() {
        // 保存下点击的第一级元素。用来后面方便的更新
        __data.$firstLevelComment = __data.$firstLevel.find("._dynamicReplyContent");
        __data.$firstLevelCount = __data.$firstLevel.find('._commentCount');
        __data.commentCount = __data.$firstLevelCount.attr('data-count');
    },
    toggle(cb1, cb2) {
        $(this).hasClass("active") ? cb2() : cb1();
        $(this).toggleClass("active");
    },
    requestFirstLevelData({type = 1, isAll = 0, page = 1}) {
        const level = 1;
        const $this = $(this);

        ajax({
            url: "/comment/getCommentListByWeiboIdAndType",
            type: "post",
            data: {
                type: type,
                isAll: isAll,
                page: page,
                weiboId: __data.weiboId
            },
            callback: ({code, data, msg}) => {
                let commentInputStr = __dynamic.showCommentHandle({type: __data.type, pid: 0, level: 1});

                if (!__data.isOpenCommentList) {
                    if (__data.isTopic) {
                        let commentModel = comment();
                        let inputDom = commentInput({level: 0, logo: $("#_currUserLogo").attr("src"), pid: 0});

                        __data.$topicCommentDom.html(commentModel);
                        __dynamic.saveFirstComment();
                        __data.$topicCommentDom.show().animate({
                            left: 0,
                            opacity: 1
                        }, 200);
                    }
                    __data.isOpenCommentList = true;
                    __data.$firstLevelComment.show().find("._dynamicComment").append(commentInputStr);
                }
                // 获取当前日期到发布评论之间的间隔时间
                data = __dynamic.dealNumberByTenThousand(__dynamic.getSinceTime(data));
                // 如果isAll等于0,表示获取第一页的列表
                // 这个时候就渲染一次评论框
                if (isAll == 0) {
                    __data.$firstLevelComment
                        .find("._dynamicFirstList")
                        .html(dynamicItem({list: data, type: type, level: level, uid: $('#_currUserUid').val()}))
                        .end();
                    __dynamic.hideShow(__data.$firstLevelComment);
                    __data.$firstLevelComment.show();
                } else {
                    // 当点击查看全部评论的时候就获取从第九条之后的数据。渲染之后追加到页面中
                    __data.$firstLevelComment.append(dynamicItem({list: data.slice(10), type: type, level: level}));
                    // 并且隐藏掉查看全部评论的按钮
                    __data.$firstLevelComment.find("._loadAllCommentBtn").hide();
                }
            }
        });
    },
    getSecondLevelComment() {
        let {id} = $(this).data();

        __data.commentId = id;
        // 保存下当前点击的二级回复评论框外层dom
        __data.$secondLevelCommentList = $(this).parents("._commentLevelOne").find("._commentLevelTwoList");
        __dynamic.toggle.call(this, () => {
            __dynamic.lookSecondLevelHandle();
        }, () => {
            __data.$secondLevelCommentList.hide().empty().removeClass('slideUp');
        });
    },
    // 查看二级的操作，主要用于回复了和点击评论展示评论列表
    lookSecondLevelHandle() {
        this.requestSecondLevelComment({page: __data.subPage, isAll: 0})
            .then((data) => {
                if (data.length > 0) {
                    data = data.map(item => {

                        // 显示回复用户 回复 当前用户
                        item.content = `回复 <a class="highlight" href='/user/index?uid=${item.reply_user.uid}'>${item.reply_user.real_name}</a>: ${item.content}`;

                        return item;
                    });
                    // 当前的子评论的字符串
                    let leafStr = '';
                    let secondLevelList = __data.$secondLevelCommentList;
                    let itemData = {level: 2, uid: $('#_currUserUid').val()};

                    // 如果当前是隐藏状态。就显示出来
                    if (!secondLevelList.hasClass('slideUp')) {
                        // 如果是第一次点开评论。就获取全部数据，并且更新整个列表
                        itemData.list = data;

                        leafStr = dynamicItem(itemData);

                        secondLevelList.html(leafStr).show().addClass('slideUp');
                        // 如果已经显示出来了。就直接插入当前的数据
                    } else {
                        // 获取当前的数据列表的最后一项。并且插入到当前评论列表最后
                        itemData.list = data.slice(data.length - 1);
                        leafStr = dynamicItem(itemData);
                        secondLevelList.append(leafStr);

                    }
                    __dynamic.hideShow(secondLevelList);
                }
            });
    },
    requestSecondLevelComment({page = 1, isAll = 0}) {
        let $this = $(this);

        return new Promise((resolve, reject) => {
            ajax({
                url: "/comment/getCommentByIdChildList",
                type: "post",
                data: {
                    commentId: __data.commentId,
                    page: page,
                    isAll: isAll
                },
                callback: ({code, data}) => {
                    if (code !== 0) {
                        if (code == 302) {
                            window.location.href = '/login/index';
                        }
                        layer.msg(msg);
                        return false;
                    }
                    resolve(__dynamic.dealNumberByTenThousand(__dynamic.getSinceTime(data)));
                }
            });
        });
    },
    // 评论的请求操作
    commentRequetHandle({val = "", pid}) {
        return new Promise((resolve, reject) => {
            if (!val) {
                reject();
                return false;
            }
            ajax({
                url: "/comment/addComment",
                type: "post",
                data: {
                    content: val,
                    fromId: __data.fromId,
                    pid: pid,
                    type: __data.type
                },
                callback: ({code, msg}) => {
                    if (code !== 0) {
                        layer.msg(msg);
                        reject();

                        return false;
                    }
                    layer.msg("提交成功");
                    resolve();
                },
                errorCallback() {
                    reject();
                }
            });
        });
    },
    // 设置一级评论的数量
    // 根据页面地址来确定不同的地方渲染数据
    // 如果不是topicDetail.表示是动态列表的的评论。那么就渲染成当前条数+条评论，
    // 如果是topicDetail，那么就是话题列表的评论。就只修改评论数量
    setFirstLevelCount(type) {
        if (pathname.indexOf('topicDetail') > -1) {
            __data.$firstLevelCount.text(__data.commentCount);
        } else {
            let str = __data.commentCount > 0 ? window.util.getNumberByTenThousand(+__data.commentCount) + '条评论' : '添加评论';

            __data.$firstLevelCount.text(str);
        }
        __data.$firstLevelCount.attr('data-count', __data.commentCount);
    },
    // 提交评论
    commentHandle() {
        let _commentInput = $(this).parent().find('._commentTextInput'),
            val = _commentInput.val().substring(0, 1000),
            {pid, level} = $(this).data(),
            $this = $(this),
            isArticleType = $(this).parents('.m-person').attr('data-orgtype');

        $(this).attr('disabled', true).text('评论中...');
        __dynamic.commentRequetHandle({
            val: val,
            type: __data.type,
            pid: pid
        }).then(() => {
            _commentInput.val("");
            // 评论完成之后。如果是一级的评论。就在获取一下当前的评论数量
            if (level == 1) {
                __data.commentCount++;
                __dynamic.setFirstLevelCount();
                __dynamic.requestFirstLevelData({type: __data.type, page: __data.page});
            } else {
                // 更新当前的评论数量
                __data.subCommentCount++;

                if (level == 2) {
                    __data.$secondLevelCommentInput.hide().empty();
                } else {
                    __data.$threeLevelCommentInput.hide().empty();
                }
                __data.$secondLevelCountDom.text(window.util.getNumberByTenThousand(+__data.subCommentCount));
                // 移除掉当前按钮上用来控制是否显示输入框的class
                $this.removeClass('active');
                __dynamic.lookSecondLevelHandle();
            }
            $this.removeAttr('disabled').text('评论');
            // 如果是二级的话只需要再次获取当前的一级评论
        }).catch(() => {
            $this.removeAttr('disabled').text('评论');
        });

    },
    // 加载全部的一级评论
    loadAllFirstLevelComment() {
        let {id} = $(this).data();
        // 获取当前的类型。然后去获取全部数据

        __dynamic.requestFirstLevelData({type: __data.type, isAll: 1, page: 1});
    },
    // 点击分享图。显示大图
    showBigImgHandle() {
        var src = $(this).attr("data-ori-src");
        var start = $(this).attr('data-index');
        const imgList = $(this).parent().find('._showBigImg');
        let json = {title: '', id: 1, "start": start, data: []};

        imgList.each((index, item) => {
            json.data.push({
                "alt": "",
                "pid": index,
                "index": index,
                "src": $(item).attr("src"),
                "thumn": $(item).attr("src")
            });
        });
        layer.photos({
            photos: json,
            area: ['400px', 'auto'],
            shade: 0.5
        });
    },
    // 收藏和取消收藏操作
    handleCollect() {
        let $this = $(this);
        let requestUrl = '',
            tip = '',
            btnText = '',
            type = __data.type;
        let {id} = $this.data();

        if (!$this.hasClass('collect')) {
            requestUrl = '/Collect/addArticleCollect';
            tip = '收藏';
            btnText = '取消收藏';
        } else {
            requestUrl = '/collect/delArticleCollect';
            tip = '取消收藏';
            btnText = '收藏';
        }
        $this.toggleClass('collect');

        ajax({
            url: requestUrl,
            type: "post",
            data: {
                aid: id,
                type: type
            },
            callback: ({code, msg}) => {
                if (code !== 0) {
                    layer.msg(msg);
                    return false;
                }
                layer.msg(`${tip}成功`);
                $this.find('._labelText').text(btnText);
            }
        });
    },
    // 显示举报弹窗操作
    showReportModel() {
        let reportmodel = reportModel();

        __data.reportId = $(this).data("id");
        $("body").append(reportmodel);
    },
    // 举报问题的类型选择操作
    selectReportType() {
        let {type} = $(this).data();
        let itemList = $(this).parent().find("._reportTypeItem");

        $(this).parents("#_reportModel").find("._otherTypeContent").removeClass("m-tip-right-active");
        // 如果当前选择的举报类型和上一次选择的不同。就让当前的类型加上active的class。
        // 并且保存当前选择的类型
        if (__data.reasonType !== type) {
            $(this).addClass("active");
            itemList.eq(__data.reasonType - 1).removeClass("active");
            __data.reportReason = $(this).text();
            __data.reasonType = type;
        }
    },
    // 选择其他问题的时候增加样式
    addOtherReportAreaClass() {
        let len = $(this).val().length;

        $(this).next().find("._currReportOtherMsgLen").text(len);
    },
    // 当其他的输入框获取焦点。说明现在用户选择的举报类型为其他
    // 就让之前选中的其他类型的class取消掉
    focusReportAreaHandle() {
        $(this)
            .parent().addClass("m-tip-right-active")
            .parent()
            .find("._reportTypeItem").eq(__data.reasonType - 1).removeClass("active");
        __data.reasonType = 4;
    },
    // 点击举报按钮操作
    submitReportHandle() {
        let reportModel = $("#_reportModel");
        let reportType = reportModel.find("._reportTypeItem");
        let content = reportModel.find("._inputOtherMsgArea").val();

        if (!__data.reasonType) {
            layer.msg('请选择举报问题类型');
            return false;
        }

        if (__data.reasonType == 4 && content == '') {
            layer.msg('请填写举报问题原因');
            return false;
        }

        ajax({
            url: "/report/addReport",
            type: "post",
            data: {
                fromId: __data.reportId,
                reason: __data.reportReason,
                type: "2",
                reasonType: __data.reasonType,
                content: content
            },
            callback: ({code}) => {
                if (code !== 0) {
                    layer.msg(msg);
                    return false;
                }
                layer.msg("举报成功");
                __dynamic.closeModelHandle();
            }
        });
    },
    // 删除动态操作
    deleteDymnicHandle() {
        let $this = $(this);
        let {id} = $this.data();

        layer.confirm("您确定要删除此条动态？不确定请点击取消", {}, () => {
            ajax({
                url: "/sns/delWeibo",
                type: "post",
                data: {
                    weiBoId: id
                },
                callback: ({code, msg}) => {
                    if (code !== 0) {
                        layer.msg(msg);
                        return false;
                    }
                    $this.parents("._dynamicMainContent").remove();
                    layer.msg("删除动态成功");
                }
            });
        });
    },
    // 显示转发弹框
    showTransmitBox() {
        let {user, id, type} = $(this).data(),
            msg = $(this).parent().find("._userCurrDymn").val(),
            defaultShowMsg = msg.length > 18 ? (msg.slice(0, 18) + "...") : msg,
            isShowBtn = msg.length > 18 ? true : false;

        __data.transmitUser = user;
        __data.transmitMsg = msg;
        __data.transmitId = id;
        __data.transmitType = type;

        $("body").append(transmitModel({user: user, msg: defaultShowMsg, isShowBtn: isShowBtn, type}));
    },
    // 显示全部的转发信息
    showFullTransmitHandle() {
        $(this).hide().parent().find("._currDynmMsg").text(__data.transmitMsg);
    },
    // 输入评论内容的操作
    inputTransmitMessageHandle() {
        let len = $(this).val().length;

        $("#_transmitModel ._currInputMessageCount").text(len);
    },
    // 发布转发评论操作
    submitTransmitHandle() {
        let transmitModel = $("#_transmitModel"),
            transmitContent = transmitModel.find("._inputOwnMessageArea").val(),
            isComment = transmitModel.find("._asCommentBtn").hasClass("icon-xuanzhong") ? 1 : 0,
            sourceType = 'weibo',
            transmitUser = $('.login-info span').text(),
            issue = $('#issue').val();

        if (__data.type === 6) {
            sourceType = 'news';
        }

        transmitContent = transmitContent == '' ? '转发动态' : transmitContent;

        __data.fromId = __data.transmitId;

        ajax({
            url: "/sns/issueWeibo",
            type: "post",
            data: {
                content: transmitContent,
                from: "web",
                issue: issue ? issue : 1,
                groupId: $('#tribeId').val(),
                nickName: transmitUser,
                repostId: __data.transmitId,
                sourceId: __data.transmitId,
                sourceType: sourceType,
                iscomment: isComment
            },
            callback: ({code, msg}) => {
                if (code !== 0) {
                    layer.msg(msg);
                    return false;
                }
                layer.msg("转发成功");
                __dynamic.closeModelHandle();

                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        });
    },
    // 关闭弹出层操作
    closeModelHandle() {
        $("._currModel").remove();
    },
    // 组织动态文章点击跳转详情
    locationArticleDetail() {
        let id = $(this).attr('data-id');

        window.location.href = `/article/articledetail?aid=${id}`;
    },
    // 删除评论操作
    deleteCommentHandle() {
        let $this = $(this);
        let {id, level} = $this.data();
        let type = __data.type;

        layer.confirm("您确定要删除此条动态？不确定请点击取消！", {}, () => {
            ajax({
                url: "/comment/delComment",
                type: "post",
                data: {
                    id: id,
                    type: type
                },
                callback: () => {
                    layer.msg("删除评论成功");
                    __data.$secondLevelCountDom = $this.parents('._commentLevelOne').find('._secondLevelCount');
                    __data.subCommentCount = __data.$secondLevelCountDom.text();
                    $this.parents('._commentLevelThree').remove();
                    if (level == 2) {
                        __data.commentCount--;
                        __dynamic.setFirstLevelCount();
                        __dynamic.requestFirstLevelData({type: __data.type, isAll: 0, page: 1});
                    } else {
                        // 删除成功后重新获取数据。修改评论数量
                        __dynamic.requestSecondLevelComment({
                            page: __data.subPage,
                            isAll: 1
                        }).then((data) => {
                            const leafStr = dynamicItem({level: 2, uid: $('#_currUserUid').val(), list: data});

                            __data.subCommentCount--;
                            __data.$secondLevelCountDom.text(__data.subCommentCount);
                            __data.$secondLevelCommentList.html(leafStr);
                        });
                    }
                }
            });
        });
    },
    // 点击是否需要转发为动态按钮点击操作
    handleClickIsNeedPubAsDym() {
        $(this).toggleClass("icon-xuanzhong");
    },
    getOtherLevelComment() {
        const {id, pid, level} = $(this).data();

        if (level == 2) {
            const $secondLevel = $(this).parents("._commentLevelOne");

            __data.$secondLevelCommentList = $secondLevel.find("._commentLevelTwoList");
            __data.$secondLevelCountDom = $secondLevel.find('._secondLevelCount');
            // 保存下当前点击的二级回复评论框外层dom
            __data.$secondLevelCommentInput = $secondLevel.find("._commentLevelTwoInput");
            __data.commentId = id;
        } else {
            const $threeLevel = $(this).parents("._commentLevelThree");

            __data.$secondLevelCountDom = $(this).parents('._commentLevelOne').find('._secondLevelCount');
            __data.$threeLevelCommentInput = $threeLevel.find('._commentLevelThreeInput');
            __data.commentId = pid;
        }
        __data.subCommentCount = __data.$secondLevelCountDom.text();

        // 点击的时候判断是否需要显示
        __dynamic.toggle.call(this, () => {
            let commentInputStr = __dynamic.showCommentHandle({pid: __data.commentId, level: level});

            // 分别插入2级和三级input输入框的显示位置
            if (level == 2) {
                __data.$secondLevelCommentInput.html(commentInputStr).show();
            } else {
                __data.$threeLevelCommentInput.html(commentInputStr).show();
            }

        }, () => {
            if (level == 2) {
                __data.$secondLevelCommentInput.hide().empty();
            } else {
                __data.$threeLevelCommentInput.hide().empty();
            }

        });
    },
    showCommentHandle({type = 1, pid, level = 0}) {
        let commentInputStr = dynamicComment({
            level: level,
            type: type,
            pid: pid,
            img: $("#_currUserLogo").attr("src")
        });

        return commentInputStr;
    },
    // 查看大图 视频音频
    checkoutResourse() {
        let $this = $(this),
            type = $this.attr('data-type'),
            content = '';

        if (type == 'video') {
            content = ` <video width="670" height="440" controls>
                            <source src="${$this.find('.videoSrc').attr('src')}" type="video/mp4">
                        </video>`
        } else {
            content = `<audio width="200" height="300" src="${$('._audioSrc').attr('src')}" controls></audio>`;
        }


        layer.open({
            type: 1,
            title: false,
            closeBtn: true,
            area: '680px',
            skin: 'bigImg',
            shadeClose: true,
            content: content,
        });
    },
    hideShow(dome) {
        let $comment = dome.find('.dynamin-title');

        $comment.each(function () {
            let $this = $(this);

            if ($this.height() > 125) {
                $this.addClass('comment-text-height');
                $this.parent().find('._hideShowAllComment')
                    .show()
                    .html('展开')
                    .after('<br/>');
            }
        })
    },
    init() {
        __data.isTopic = pathname.indexOf('topic') > -1 ? true : false;
        __data.type = $('#_currDynamicType').val() || 1;
    }
};

$(function () {

    __dynamic.init();
    $(document)
    // 获取一级评论
        .on("click", "._getFirstLevel", __dynamic.getFirstLevelComment)
        // 加载全部一级评论的方法
        .on("click", "._loadAllCommentBtn", __dynamic.loadAllFirstLevelComment)
        // 展开二级回复
        .on("click", "._getSecondLevel", __dynamic.getSecondLevelComment)
        // 获取一级以后的其他级别的评论框
        .on("click", "._replyBtn", __dynamic.getOtherLevelComment)
        // 评论方法
        .on("click", "._commentBtn", __dynamic.commentHandle)
        // 删除评论方法
        .on("click", "._deleteCommentBtn", __dynamic.deleteCommentHandle)

        // 显示举报弹窗操作
        .on("click", "._showReportBtn", __dynamic.showReportModel)
        // 举报问题的类型点击操作
        .on("click", "#_reportModel ._reportTypeList span", __dynamic.selectReportType)
        // 举报其他问题输入时候的操作
        .on("input", "#_reportModel ._inputOtherMsgArea", __dynamic.addOtherReportAreaClass)
        // 获取焦点时让当前保持选中
        .on("focus", "#_reportModel ._inputOtherMsgArea", __dynamic.focusReportAreaHandle)
        // 提交举报问题的操作
        .on("click", "#_reportModel ._submitReportBtn", __dynamic.submitReportHandle)

        // 转发操作
        // 显示转发弹窗
        .on("click", "._showTransmitBtn, ._shareBtn", __dynamic.showTransmitBox)
        // 点击显示转发所有内容按钮
        .on("click", "#_transmitModel ._showFullTransmitMsgBtn", __dynamic.showFullTransmitHandle)
        // 点击转发按钮操作
        .on("click", "#_transmitModel ._publishTransmitHandle", __dynamic.submitTransmitHandle)
        // 输入想法的操作
        .on("input", "#_transmitModel ._inputOwnMessageArea", __dynamic.inputTransmitMessageHandle)
        // 是否需要把当前动态作为评论发布按钮点击
        .on("click", "#_transmitModel ._asCommentBtn", __dynamic.handleClickIsNeedPubAsDym)

        // 收藏操作
        .on("click", "._collectBtn", __dynamic.handleCollect)
        // 关闭弹框操作
        .on("click", "._closeModelBtn", __dynamic.closeModelHandle)
        // 删除动态
        .on("click", "._deleteDynamicBtn", __dynamic.deleteDymnicHandle)
        .on("click", "._thumbBtn", __dynamic.handleThumbs)

        // 组织动态文章点击跳转详情
        .on("click", "._articleContent", __dynamic.locationArticleDetail)
        // 点击动态中的图片显示大图
        .on("click", "._showBigImg", __dynamic.showBigImgHandle)
        // 话题视频点击显示大图
        .on("click", "._checkoutResourse", __dynamic.checkoutResourse)
        // 展开收起
        .on('click', '._hideShowAllComment', function () {
            let $this = $(this);
            let msg = $this.html() == '展开' ? '收起' : '展开';

            $this.html(msg)
                .parent()
                .find('.dynamin-title')
                .toggleClass('comment-text-height')
        });
});